<template>
  <div>

    <job-demand-dialog
      v-model:visible="jobDemandVis"
    />

    <common-msg-dialog
      v-model:visible="commonDiaVis"
      :current-row="commonDiaRow"
    />

  </div>
</template>

<script setup lang="jsx">
/*
 * 学习中心各种弹层，按照优先级，控制器。  所有弹层均在此组件。
 */
import JobDemandDialog from "./JobDemandDialog.vue";
import {useUserInfoStore} from "@/store/modules/userInfo.js";
import {findBeginRemind, readMsgApi} from "@/api/examCenter/pop.js";
import {ElMessageBox} from "element-plus";
import CommonMsgDialog from './CommonMsgDialog.vue'

onBeforeMount(() => {
  handler()
})

const userInfoStore = useUserInfoStore()

/* 弹窗优先级(实际下面pc只有2个)
1.版本更新 (pc无)
2.课表推送、广告弹窗提醒(原本为9，但接口做成一个了)
3.有一项就业服务等待你的评分(pc无)
4.学员评价推送(pc无)
5、是否有就业需求
6.结课证领取弹窗(pc无)
7.结课证 评价(pc无)
8.规划书(pc无)
*/

const commonDiaVis = ref(false)
const commonDiaRow = ref({})

async function handler() {
  const popRes = await findBeginRemind({
    pageNum: 1,
    pageSize: 1,
    dialogFlag: 1,
    readFlag: 0
  })
  if (popRes.data && popRes.data.data && popRes.data.data[0]) { // 最新的一条有数据
    commonDiaRow.value = popRes.data.data[0]
    commonDiaVis.value = true
    return
  }

  const data = await userInfoStore.getUserInfo()
  if (data.isPopUp == 1) { // 就业需求弹层处理
    jobDemandVis.value = true
    return
  }
}

const jobDemandVis = ref(false)
</script>

<style scoped lang="scss">

</style>
